import { render, staticRenderFns } from "./add-new-client-member.vue?vue&type=template&id=60766d8c&scoped=true&"
import script from "./add-new-client-member.vue?vue&type=script&lang=js&"
export * from "./add-new-client-member.vue?vue&type=script&lang=js&"
import style0 from "./add-new-client-member.vue?vue&type=style&index=0&id=60766d8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60766d8c",
  null
  
)

component.options.__file = "add-new-client-member.vue"
export default component.exports